import axios, { AxiosError } from 'axios';
import { auth } from '../firebase'; // your firebase.ts file
import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";


interface ApiError {
  message?: string;
}

export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});


type Profile = {
  avatar?: string;
  info?: string;
  skills: string[];
  interests: string[];
};

type Motivation =
  | "Libertad"
  | "Ingreso extra"
  | "Impacto"
  | "Construir en grande"
  | "Creatividad";

type Idea = {
  nombre: string;
  descripcion: string;
  nivel_de_inversion: string;
  sector: string;
  posible_escalabilidad: string;
  tipo_actividad_economica: string;
  modelo_de_negocio: string;
};

type Refinement = {
  offering: string;
  mode: "solo" | "team";
};

export type JourneyResult = {
  profile: Profile;
  motivations: Motivation[];
  selectedIdea: Idea | null;
  refinement: Refinement;
  companyImage: CompanyImage;
  recommendedTools: ToolCategory[];
  onboardingPath?: "no_idea" | "has_idea" | "established";
  acquisitionContext?: string;
  acquisitionPlan?: Record<string, unknown>;
  businessDraft?: Record<string, unknown>;
};

interface CompanyImage {
  logo_svg?: string;
  logo_url?: string;
  primaryColor?: string;
  secondaryColor?: string;
  tertiaryColor?: string;
  font?: string;
}

interface ToolCategory {
  id: number;
  name: string;
}

export const init = async (email: string, name: string) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");

    const idToken = await user.getIdToken();
    const response = await backendAPI.post(
      'auth/init',
      { email, name },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );
    return response;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Signup failed');
  }
};

export const logout = async () => {
  try {
    const response = await backendAPI.post('auth/logout/');
    return response.data;
  } catch (error: any) {
    throw new Error((error as AxiosError<ApiError>)?.response?.data?.message || 'Logout failed');
  }
};

export const signupBusinessCreate = async (
  journeyResult: JourneyResult,
  email: string, 
  name: string
) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not logged in");

    const idToken = await user.getIdToken();

    const payload = {
      profile: journeyResult.profile,
      motivations: journeyResult.motivations,
      selectedIdea: journeyResult.selectedIdea,
      refinement: journeyResult.refinement,
      companyImage: journeyResult.companyImage,
      recommendedTools: journeyResult.recommendedTools,
      onboardingPath: journeyResult.onboardingPath,
      acquisitionContext: journeyResult.acquisitionContext,
    };

    let imageUrl: string | undefined;

    if (payload.companyImage.logo_svg) {
      const svgBlob = new Blob([payload.companyImage.logo_svg], { type: 'image/svg+xml' });
      const fileRef = ref(storage, `logos/${Date.now()}-logo.svg`);

      await uploadBytes(fileRef, svgBlob);
      imageUrl = await getDownloadURL(fileRef);
    }
    const onboardingPayload = {
      ...payload,
      companyImage: {
        ...payload.companyImage,
        logo_url: imageUrl,
      },
    };
    console.log('Onboarding Payload:', onboardingPayload);
    console.log('Token:', idToken);
    const response = await backendAPI.post(
      'auth/signupcreatebusiness',
      { onboardingPayload, email, name },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return response;
  } catch (error: any) {
    throw new Error(
      (error as AxiosError<ApiError>)?.response?.data?.message || 'Signup with business failed'
    );
  }
};
